<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
    </button>

    <p class="mat-headline mb-4" [innerHTML]="data.text|translate:data.params"></p>

    <div>
        <div class="row justify-content-between">
            <div class="col-12 col-sm-5">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" [mat-dialog-close]="false">
                    <span *ngIf="data.cancel" [translate]="data.cancel"></span>
                    <span *ngIf="!data.cancel">{{ 'general.cancel'|translate }}</span>
                </button>
            </div>
            <div class="col-12 col-sm-5 mt-3 mt-sm-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="true">
                    <span *ngIf="data.ok" [translate]="data.ok"></span>
                    <span *ngIf="!data.ok">{{ 'general.accept'|translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
